// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2B_5-","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1oMx-"};